(function () {
  if (window.__dcroStickyAtcDraft) return;
  window.__dcroStickyAtcDraft = true;

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  ready(function () {
    var primaryButton = document.querySelector('.product__info-container button[name="add"]:not(.dcro-sticky-atc__button), product-form button[name="add"]:not(.dcro-sticky-atc__button), form[action*="/cart/add"] button[name="add"]:not(.dcro-sticky-atc__button)');
    if (!primaryButton || document.querySelector('.dcro-sticky-atc')) return;

    var productInfo = primaryButton.closest('.product__info-container') || document;
    var titleSource = document.querySelector('.product__title h1, h1');
    var priceSource = productInfo.querySelector('.price, [class*="price"]') || document.querySelector('.price, [class*="price"]');

    var bar = document.createElement('div');
    bar.className = 'dcro-sticky-atc';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = [
      '<button class="dcro-sticky-atc__close" type="button" aria-label="Lukk">&times;</button>',
      '<div class="dcro-sticky-atc__meta">',
      '  <div class="dcro-sticky-atc__title"></div>',
      '  <div class="dcro-sticky-atc__price"></div>',
      '</div>',
      '<button class="dcro-sticky-atc__button" type="button"></button>'
    ].join('');
    document.body.appendChild(bar);

    var titleNode = bar.querySelector('.dcro-sticky-atc__title');
    var priceNode = bar.querySelector('.dcro-sticky-atc__price');
    var stickyButton = bar.querySelector('.dcro-sticky-atc__button');
    var closeButton = bar.querySelector('.dcro-sticky-atc__close');
    var personalizer = document.querySelector('[data-daniel-personalizer]');
    var mobileQuery = window.matchMedia('(max-width: 749px)');
    var scheduled = false;
    var dismissed = false;
    var personalizationValid = !personalizer || personalizer.getAttribute('data-complete') === 'true';
    var personalizationLabel = personalizer && personalizer.dataset.completeLabel || '';

    function clean(value) {
      return String(value || '').replace(/\s+/g, ' ').trim();
    }

    function primaryButtonText() {
      if (!personalizationValid && personalizationLabel) return personalizationLabel;
      var label = clean(primaryButton.innerText || primaryButton.textContent);
      return label || primaryButton.getAttribute('aria-label') || 'Legg i handlekurv';
    }

    function currentPriceText() {
      var source = productInfo.querySelector('.price__sale .price-item--sale, .price-item--sale, .price__regular .price-item--regular, .price-item--regular') || priceSource;
      if (!source) return '';
      var text = clean(source.innerText || source.textContent);
      text = text.replace(/Vanlig pris|Salgspris|Försäljningspris|Normaali hinta|Alennushinta|Regular price|Sale price/gi, ' ');
      text = clean(text);
      var matches = text.match(/(?:kr\s*)?\d[\d\s.,]*(?:,-)?\s*(?:kr|DKK)\b|(?:kr\s*)?\d[\d\s.]*,-|€\s?\d[\d\s.,]*|\d[\d\s.,]*\s*€/gi);
      if (matches && matches.length) return clean(matches[matches.length - 1]).slice(0, 34);
      return text.slice(0, 34);
    }

    function closeLabel() {
      var lang = (document.documentElement.lang || '').toLowerCase();
      if (lang.indexOf('en') === 0 && window.Shopify && window.Shopify.country === 'CA') return 'Close';
      if (lang.indexOf('sv') === 0) return 'Stäng';
      if (lang.indexOf('fi') === 0) return 'Sulje';
      if (lang.indexOf('da') === 0) return 'Luk';
      return 'Lukk';
    }

    function syncContent() {
      titleNode.textContent = clean(titleSource && (titleSource.innerText || titleSource.textContent)).slice(0, 90);
      priceNode.textContent = currentPriceText();
      stickyButton.textContent = primaryButtonText();
      stickyButton.disabled = Boolean(primaryButton.disabled || primaryButton.getAttribute('aria-disabled') === 'true');
      closeButton.setAttribute('aria-label', closeLabel());
    }

    function shouldShow() {
      if (dismissed) return false;
      if (!mobileQuery.matches) return false;
      if (!document.body || document.body.classList.contains('overflow-hidden')) return false;
      var rect = primaryButton.getBoundingClientRect();
      /* gh 26.09: vis knappen hele tiden når den ekte kjøpsknappen ikke er på skjermen (over eller under) */
      var offscreen = rect.bottom < 0 || (rect.top > window.innerHeight - 20 && (window.scrollY || window.pageYOffset || 0) > 160);
      return offscreen && document.documentElement.scrollHeight > window.innerHeight + 240;
    }

    function updatePreviewOffset() {
      var wrapper = document.getElementById('PBarNextFrameWrapper');
      var offset = 0;
      if (wrapper) {
        var rect = wrapper.getBoundingClientRect();
        if (rect.height && rect.bottom > window.innerHeight - 4) {
          offset = Math.ceil(rect.height);
        }
      }
      document.documentElement.style.setProperty('--dcro-sticky-preview-offset', offset + 'px');
    }

    function setVisible(visible) {
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      document.body.classList.toggle('dcro-sticky-atc-visible', visible);
    }

    function update() {
      scheduled = false;
      syncContent();
      updatePreviewOffset();
      setVisible(shouldShow());
    }

    function scheduleUpdate() {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(update);
    }

    stickyButton.addEventListener('click', function () {
      syncContent();
      /* gh 26.09: er kjøpsknappen fortsatt lenger ned (kunden har ikke sett valg og pris), vis kjøpsboksen i stedet for å legge i kurven blindt */
      var pr = primaryButton.getBoundingClientRect();
      var hasChoices = !!productInfo.querySelector('variant-selects, variant-radios, .product-form__input--pill, .product-form__input--dropdown, [data-daniel-personalizer]');
      if (pr.top > window.innerHeight - 20 && hasChoices) {
        var target = productInfo.querySelector('variant-selects, variant-radios') || primaryButton;
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      if (stickyButton.disabled) {
        primaryButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      primaryButton.click();
    });

    document.addEventListener('daniel:personalization-state', function (event) {
      if (!personalizer || event.target !== personalizer) return;
      personalizationValid = Boolean(event.detail && event.detail.valid);
      if (event.detail && event.detail.completeLabel) personalizationLabel = event.detail.completeLabel;
      scheduleUpdate();
    });

    closeButton.addEventListener('click', function () {
      dismissed = true;
      setVisible(false);
    });

    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate);
    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', scheduleUpdate);
    } else if (mobileQuery.addListener) {
      mobileQuery.addListener(scheduleUpdate);
    }

    if ('MutationObserver' in window) {
      new MutationObserver(scheduleUpdate).observe(productInfo, {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true
      });
    }

    syncContent();
    scheduleUpdate();
  });
})();
